module.exports = "/images/thumbnails-icon.svg?d1aca8db3728d1d2600c5d75b812ad89";